<template>
  <v-app>
    <v-main class="admin-login">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="9" lg="8" xl="7">
            <v-card class="login-shell" elevation="0">
              <v-row no-gutters>
                <v-col cols="12" md="5" class="login-brand pa-8 pa-lg-12">
                  <v-img
                    src="~@/assets/logo.png"
                    contain
                    max-width="230"
                    class="mb-12"
                  />
                  <div class="login-kicker mb-4">OPERATIONS CENTER</div>
                  <h1 class="login-headline mb-5">Payments im Blick. Entscheidungen im Griff.</h1>
                  <p class="login-copy mb-8">
                    Die zentrale Arbeitsoberfläche für Transaktionen, Banking,
                    KYC und Kundenverwaltung.
                  </p>
                  <div class="login-status">
                    <span class="status-dot"></span>
                    Sichere Admin-Verbindung
                  </div>
                </v-col>
                <v-col cols="12" md="7" class="login-form pa-8 pa-lg-12">
                  <div class="login-eyebrow mb-2">Willkommen zurück</div>
                  <h2 class="login-title mb-2">{{ $t("adminLog") }}</h2>
                  <p class="login-subtitle mb-8">
                    Melden Sie sich mit Ihrem Administratorkonto an.
                  </p>
                <v-form ref="form" v-model="valid" @keyup.native.enter="login">
                  <v-text-field
                    id="email"
                    v-model="form.email"
                    :label="$t('Login')"
                    name="login"
                    prepend-inner-icon="mdi-email-outline"
                    outlined
                    type="text"
                    :rules="rules.email"
                    :disabled="sending"
                    @input="serverErrors = null"
                  />
                  <v-text-field
                    id="password"
                    v-model="form.password"
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="$t('user.Password')"
                    name="password"
                    prepend-inner-icon="mdi-lock-outline"
                    outlined
                    :type="showPass ? 'text' : 'password'"
                    counter
                    :rules="rules.password"
                    :disabled="sending"
                    @click:append="showPass = !showPass"
                    @input="serverErrors = null"
                  />

                  <v-text-field
                    id="one_time_password"
                    v-model="form.one_time_password"
                    type="text"
                    prepend-inner-icon="mdi-shield-key-outline"
                    outlined
                    counter="6"
                    name="one_time_password"
                    :label="$t('2fa.password')"
                  />
                </v-form>
                <v-btn
                  color="primary"
                  x-large
                  block
                  depressed
                  class="login-submit mt-2"
                  :loading="sending"
                  @click="login"
                >
                  {{ $t("Login") }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              <v-progress-linear
                v-if="sending"
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
              <v-alert v-if="errorMessage" tile class="mt-5" type="error">{{
                errorMessage
              }}</v-alert>
                <div class="login-api mt-8">API: {{ apiUrl }}</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      rules: {
        password: [
          (v) => !!v || "Required.",
          (v) => (v ? v.length >= 8 || "Min 8 characters" : "Required."),
          () =>
            this.serverErrors && this.serverErrors.password
              ? this.serverErrors.password[0]
              : true,
        ],
        email: [
          (v) => !!v || "Required.",
          (v) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(v) || "Invalid e-mail.";
          },
          () =>
            this.serverErrors && this.serverErrors.email
              ? this.serverErrors.email[0]
              : true,
        ],
      },
      showPass: false,
      errorMessage: null,
      serverErrors: null,
      sending: false,
      valid: false,
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
  methods: {
    login() {
      this.errorMessage = null;
      this.serverErrors = null;
      if (this.$refs.form.validate()) {
        this.apiLogin()
          .then(() => {
            this.$router.push(this.$route.query.from || "/");
          })
          .catch((error) => {
            this.errorMessage = error.message;
            this.serverErrors = error.errors;
            this.$refs.form.validate();
          });
      }
    },
  },
};
</script>

<style scoped>
.admin-login {
  background:
    radial-gradient(circle at 85% 15%, rgba(20, 176, 191, 0.2), transparent 28%),
    radial-gradient(circle at 12% 88%, rgba(176, 214, 48, 0.12), transparent 32%),
    #071c2d;
}
.login-shell { overflow: hidden; border-radius: 24px; }
.login-brand { color: #fff; background: linear-gradient(150deg, #0a3552, #0b5b78); }
.login-kicker, .login-eyebrow { color: #9bcf31; font-size: 12px; font-weight: 800; letter-spacing: .16em; }
.login-headline { font-size: clamp(30px, 3vw, 44px); line-height: 1.05; letter-spacing: -.04em; }
.login-copy { color: rgba(255,255,255,.72); font-size: 16px; line-height: 1.7; }
.login-status { font-size: 13px; color: rgba(255,255,255,.78); }
.status-dot { display: inline-block; width: 8px; height: 8px; margin-right: 9px; border-radius: 50%; background: #9bcf31; box-shadow: 0 0 0 5px rgba(155,207,49,.14); }
.login-form { background: #fff; }
.login-title { color: #0a2940; font-size: 34px; letter-spacing: -.03em; }
.login-subtitle, .login-api { color: #718194; }
.login-api { font-size: 11px; word-break: break-all; }
.login-submit { border-radius: 12px; font-weight: 800; letter-spacing: .02em; }
</style>
